import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

// Interfaces
interface IStyledCheckboxProps {
  checked: boolean
}
interface ICheckboxProps {
  name: string
  label?: string
  checked: boolean
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

// Styled components
const CheckboxWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
`
const Icon = styled.svg`
  fill: none;
  stroke-width: 4px;
  stroke: ${(props) => props.theme.colors.neutralColor900};
`
const Label = styled.label`
  & span {
    padding-left: 8px;
  }
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`
const StyledCheckbox = styled.div<IStyledCheckboxProps>`
  display: inline-block;
  width: 16px;
  height: 16px;
  background: ${(props) =>
    props.checked ? props.theme.colors.primaryColor500 : props.theme.colors.neutralColor100};
  border-radius: 3px;
  transition: all 150ms;
  ${HiddenCheckbox}:focus + & {
    box-shadow: ${(props) => `0 0 0 3px ${props.theme.colors.primaryColor700}`};
  }
  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }
`

const Checkbox: FunctionComponent<ICheckboxProps> = ({ name, label, checked, value, ...props }) => {
  return (
    <Label>
      <CheckboxWrapper>
        <HiddenCheckbox checked={checked} {...props} name={name} value={value} />
        <StyledCheckbox checked={checked}>
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
      </CheckboxWrapper>
      {label && <span>{label}</span>}
    </Label>
  )
}

export default Checkbox
